import { SaveButton } from '@core/components/Buttons';
import { Divider, Grid, Typography } from '@material-ui/core';
import { AnexoUnico } from 'app/components/Anexo';
import CircularProgressBar from 'app/utils/CircularProgressBar';
import React from 'react';
import { FaFileExcel } from 'react-icons/fa';
import SockJsClient from 'react-stomp';

const ImportModal = ({ onFileChange, arquivo, obterModelo, progress, handleProgressUpdate, formik }) => {
  const _errors = {
    arquivo: (formik?.submitCount > 0 || formik?.touched?.arquivo) && formik?.errors?.arquivo,
  };
  return (
    <>
      <Grid container style={{ padding: 16, marginBottom: 10 }} spacing={4}>
        <Grid item xs={12} style={{ display: 'flex' }}>
          <Grid item xs={3}>
            <FaFileExcel size={100} color="#233D4D" />
          </Grid>
          <Grid item xs={9} style={{ display: 'flex', alignItems: 'center' }}>
            <Typography>
              Faça o download da nossa planilha modelo, preencha as informações e importe para o sistema.
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SaveButton color="buttonSave" type="button" onClick={() => obterModelo()}>
            Baixar planilha
          </SaveButton>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid container style={{ padding: 16 }} spacing={4}>
        <Grid item xs={12}>
          <Typography>Agora é só importar a planilha preenchida acionando o comando abaixo.</Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <AnexoUnico
            id="arquivo"
            name="arquivo"
            label="Arquivo"
            placeholder="Selecione a planilha"
            accept=".xlsx"
            onFileChange={onFileChange}
            arquivo={arquivo}
            error={_errors.arquivo}
            helperText={_errors.arquivo}
            touched={!!_errors.arquivo}
            required
          />
        </Grid>
      </Grid>

      {arquivo && (
        <Grid item xs={12} style={{ margin: 15 }}>
          <CircularProgressBar progress={progress} />
        </Grid>
      )}

      <SockJsClient
        url={`${process.env.REACT_APP_WEBSOCKET_URL}`}
        topics={['/topic/notificacao']}
        onConnect={() => {
          console.log('Conectado ao WebSocket');
        }}
        onDisconnect={() => {
          console.log('Desconectado do WebSocket');
        }}
        onMessage={(notificacao) => {
          handleProgressUpdate(notificacao);
        }}
      />
    </>
  );
};

export default ImportModal;
